
import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { User, Bookmark, Clock, LayoutDashboard } from "lucide-react";
import ProfileForm from "./ProfileForm";
import SavedItems from "./SavedItems";
import BrowsingHistory from "./BrowsingHistory";
import ProfileDashboard from "./ProfileDashboard";

interface ProfileTabsProps {
  activeTab: string;
  setActiveTab: (value: string) => void;
  profile: any;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  handleSubmit: (e: React.FormEvent) => void;
  uploading: boolean;
  autoSaved?: boolean;
  handleImageUpload?: (url: string) => void;
  savingState?: 'idle' | 'saving' | 'saved' | 'error';
  isProfileComplete?: boolean;
}

const ProfileTabs = ({ 
  activeTab, 
  setActiveTab, 
  profile, 
  handleChange, 
  handleSubmit,
  uploading,
  autoSaved,
  handleImageUpload,
  savingState,
  isProfileComplete
}: ProfileTabsProps) => {
  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-6">
      <TabsList className="grid grid-cols-4 w-full max-w-md mx-auto">
        <TabsTrigger value="dashboard" className="flex items-center gap-2">
          <LayoutDashboard size={16} />
          <span className="hidden sm:inline">Dashboard</span>
        </TabsTrigger>
        <TabsTrigger value="profile" className="flex items-center gap-2">
          <User size={16} />
          <span className="hidden sm:inline">Profile</span>
        </TabsTrigger>
        <TabsTrigger value="saved" className="flex items-center gap-2">
          <Bookmark size={16} />
          <span className="hidden sm:inline">Saved</span>
        </TabsTrigger>
        <TabsTrigger value="history" className="flex items-center gap-2">
          <Clock size={16} />
          <span className="hidden sm:inline">History</span>
        </TabsTrigger>
      </TabsList>
      
      <TabsContent value="dashboard">
        <ProfileDashboard profile={profile} />
      </TabsContent>
      
      <TabsContent value="profile">
        <ProfileForm 
          profile={profile} 
          handleChange={handleChange} 
          handleSubmit={handleSubmit} 
          uploading={uploading}
          autoSaved={autoSaved}
          handleImageUpload={handleImageUpload}
          savingState={savingState}
          isProfileComplete={isProfileComplete}
        />
      </TabsContent>
      
      <TabsContent value="saved">
        <SavedItems />
      </TabsContent>
      
      <TabsContent value="history">
        <BrowsingHistory />
      </TabsContent>
    </Tabs>
  );
};

export default ProfileTabs;
